(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  if (App.angularApp == null) {
    return;
  }


  /*
   * natSort filter
   *
   * Replacement for the native orderBy filter. Uses strnatcasecmp (from php.js)
   * when possible for comparing values. Should accept the exact same parameters
   * as the native orderBy filter.
   */

  App.angularApp.filter('natSort', [
    '$parse', (function(_this) {
      return function($parse) {
        var string_types;
        string_types = ['string', 'number'];
        return function(input, props, reverse) {
          var arr, compare;
          if (reverse == null) {
            reverse = false;
          }
          if (input && input.length) {
            arr = $.merge([], input);
          } else {
            return [];
          }
          if (!(props instanceof Array)) {
            props = [props];
          }
          compare = function(a, b) {
            var ref, ref1;
            if (a == null) {
              return -1;
            }
            if (b == null) {
              return 1;
            }
            if ((ref = typeof a, indexOf.call(string_types, ref) >= 0) && (ref1 = typeof b, indexOf.call(string_types, ref1) >= 0)) {
              return strnatcasecmp(a, b);
            }
            if (a > b) {
              return 1;
            }
            if (a < b) {
              return -1;
            }
            return 0;
          };
          return arr.sort(function(a, b) {
            var cmp, desc, i, len, prop;
            for (i = 0, len = props.length; i < len; i++) {
              prop = props[i];
              desc = false;
              if (typeof prop === 'string' && prop[0] === '-') {
                desc = true;
                prop = prop.slice(1);
              }
              cmp = compare($parse(prop)(a), $parse(prop)(b));
              if (cmp === 0) {
                continue;
              }
              if (desc) {
                cmp = -cmp;
              }
              if (reverse) {
                cmp = -cmp;
              }
              return cmp;
            }
            return 0;
          });
        };
      };
    })(this)
  ]);

}).call(this);
